package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.restaurant_manager.components.restaurant_project.list

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.Room
import org.hs_soft.runmynesto.pages.components.Separator

@Composable
fun Rooms(
    rooms: List<Room?>,
    selectedRestaurantRoom: Room?,
    windowSizeMode: WindowSizeModeEnum,
    isExpandAll: Boolean,
    onRoomClick: (Room?) -> Unit,
) {

    val isExpanded= remember{ mutableStateOf(false) }
    LaunchedEffect(isExpandAll){
        isExpanded.value=isExpandAll
    }
    rooms.forEachIndexed {index,it->
        RoomItem(
            isSelected=it?.id==selectedRestaurantRoom?.id,
            room =it,
            windowSizeMode=windowSizeMode,
            isLastItem = index==rooms.size - 1,
            onRoomClick = {
                onRoomClick(it)
            }
        )
        if (index!=rooms.size-1)
            Separator()
    }



}